<template>
    <div class="home-wrapper flex-height-max">
        <div class="home-wrapper-container">
            <div v-if="progress_bar_percentage > 0">
                <div class="progress">
                    <div class="progress-bar bg-success" role="progressbar" v-bind:style="'width:'+progress_bar_percentage+'%;'" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">{{progress_bar_text}}</div>
                </div>
                <div style="text-align: left; font-size: 12px;">Setup progress</div>
            </div>
            <template>
                <div class="header-home">
                    Connect your Google Ads account
                </div>
                <div class="flex-height-max flex-row">
                    <div class="content">
                        <div class="mb-3">Please enter the Google Ads account ID number you wish to protect.</div>
                        <custom-input
                            name="google_ads_id"
                            type="text"
                            v-model="google_ads_id"
                            placeholder="Google Ads account ID e.g. 123-456-7890"
                            :additional_handling="google_ads_pattern"
                        ></custom-input>

                        <div class="mt-3">👁️ You can find your Google Ads ID number at the top right corner of your Google Ads account window.</div>
                        <div class="verify-title mt-3">
                            ⚠️ Google Ads manager account (formerly MCC) users: <span style="font-weight: normal;">At the moment, we don't support automatic integration with MCC accounts. If you want to protect all of your sub-accounts, please submit their IDs one by one. Alternatively, you can enjoy our free setup assistance from a dedicated integration specialist. To book an integration session, <a target="_blank" style="text-decoration: underline; color: blue;" :href="'https://calendly.com/galia-s/ppc-shield-setup-assistance?a1='+user_id+'&name='+user_name+'&email='+user_email">click here</a>.</span>
                        </div>
                        <div class="mt-2" style="color: red">
                            <div>{{error}}</div>
                        </div>
                        <button class="btn btn-primary w-100 mt-3" style="margin-bottom: 80px;" v-on:click="sendRequestToGoogleAccount">NEXT</button>
                    </div>
                    <div class="content-right-side">
                        <img class="right-img" src="/images/AccountID_place.png" alt="connect">
                    </div>
                </div>
            </template>
        </div>
        <modal :height="'auto'" :width="'400px'" name="dialog-info-ads">
            <div class="informative-modal flex flex-col">
                <div class="header">
                    Warning
                </div>

                <div class="body">
                    You haven't approved access to any of the Google Ads accounts you have already requested to connect. As a security measure our system has blocked your user from requesting to connect additional Google Ads accounts. It is necessary to approve access for at least one of the previously submitted accounts to obtain reversal of blocking. If you need additional information or assistance, please contact our support team.
                </div>

                <div class="footer flex justify-end space-x-2">
                    <button class="btn" @click="hideModal">Close</button>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
    import VuePreloaders from 'vue-preloaders';
    import Infinite from '../shared/preloader.vue';
    Vue.use(VuePreloaders, {
        "component": Infinite,
        "overlayStyle": {
            "background": "rgba(0,0,0,.2)",
            "opacity": 1
        }
    });

    export default {
        props: ['user_id', 'user_name', 'user_email', 'progress_bar_percentage', 'progress_bar_text', 'default_ads_id'],
        data: function () {
            return {
                google_ads_id: this.default_ads_id,
                error: '',
            }
        },
        methods: {
            startPreloader() {
                this.preloader = this.$preloaders.open(/*{ options }*/);
            },
            stopPreloader() {
                this.preloader();
            },
            google_ads_pattern(value){
                let temp = value;
                temp = temp.replace(/\D/g,'');
                if(temp.length > 2 && temp[3] !== '-') temp = temp.splice(3, 0, '-');
                if(temp.length > 6 && temp[7] !== '-') temp = temp.splice(7, 0, '-');
                if(temp.length > 11) temp = temp.splice(12, temp.length-12, '');
                return temp;
            },
            sendRequestToGoogleAccount(){
                this.startPreloader();
                axios.post('/setup/googleAccountSave', {
                    "google_ads_id": this.google_ads_id.replace(/\D/g,'')
                })
                    .then(info => {
                        if(info.status === 200){
                            window.location.href = info.data.route;
                        }
                        this.stopPreloader();
                    })
                    .catch(info => {
                        this.stopPreloader();
                        if(info.response.data?.errors?.modal){
                            this.showModal();
                        }
                        else{
                            const message = info.response.data?.errors?.google_ads_id;
                            if(Array.isArray(message)){
                                if(message.length > 1) this.error = message[1];
                                else this.error = message[0];
                            }
                            else this.error = info.response.data?.errors?.google_ads_id;
                        }
                    });
            },
            showModal() {
                this.$modal.show('dialog-info-ads');
            },
            hideModal() {
                this.$modal.hide('dialog-info-ads');
            }
        },
        mounted() {
            String.prototype.splice = function(idx, rem, str) {
                return this.slice(0, idx) + str + this.slice(idx + Math.abs(rem));
            };
        }
    }
</script>
